<template>
  <v-dialog persistent max-width="450px" :value="profileUpdatedDialog">
    <v-card>
      <v-card-title>
        <span class="text-h6 font-weight-semibold">Profile Updated</span>
      </v-card-title>
      <v-divider class="mb-5" />
      <v-card-text class="text-body-1">
        Your profile was updated successfully. <br />
        Some changes will not take effect until you log out and log back in.
      </v-card-text>
      <v-card-actions>
        <v-btn
          class="text-capitalize"
          color="primary"
          depressed
          @click="logout()"
          >Log Out Now</v-btn
        >
        <v-btn
          depressed
          class="text-capitalize"
          @click="SET_PROFILE_UPDATED_DIALOG(false)"
          >Got It <v-icon right>mdi-thumb-up-outline</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import sharedMixin from '@/modules/shared/mixins/shared.mixin';
export default {
  mixins: [sharedMixin],
  data() {
    return {
      useSocketEmitOnly: true
    };
  },
  computed: {
    ...mapGetters('coreModule', ['profileUpdatedDialog'])
  },
  methods: {
    ...mapMutations('coreModule', ['SET_PROFILE_UPDATED_DIALOG']),
    async logout() {
      await this.signOut(this.user.id);
      this.$store.commit('authModule/CLEAR_TOKENS');
      this.$store.commit('authModule/CLEAR_USER');
      this.SET_PROFILE_UPDATED_DIALOG(false);
      this.$router.replace('/auth/login');
      this.displaySnackMessage(
        'Log out successful.',
        'Please log in again to continue.'
      );
    }
  }
};
</script>
